import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2d303921&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d303921')) {
      api.createRecord('2d303921', component.options)
    } else {
      api.reload('2d303921', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2d303921&", function () {
      api.rerender('2d303921', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/designation/edit.vue"
export default component.exports